var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddActionButon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6922 2C37.0059 2 39.6922 4.68629 39.6922 8V11.9499C39.6922 12.4803 39.9029 12.989 40.278 13.3641L43.278 16.3641C44.059 17.1452 44.059 18.4115 43.278 19.1925L40.278 22.1925C39.9029 22.5676 39.6922 23.0763 39.6922 23.6067V28C39.6922 31.3137 37.0059 34 33.6922 34H9.99989C6.68618 34 3.99989 31.3137 3.99989 28V8C3.99989 4.68629 6.68618 2 9.99989 2H33.6922Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6922 2C37.0059 2 39.6922 4.68629 39.6922 8V11.9499C39.6922 12.4803 39.9029 12.989 40.278 13.3641L43.278 16.3641C44.059 17.1452 44.059 18.4115 43.278 19.1925L40.278 22.1925C39.9029 22.5676 39.6922 23.0763 39.6922 23.6067V28C39.6922 31.3137 37.0059 34 33.6922 34H9.99989C6.68618 34 3.99989 31.3137 3.99989 28V8C3.99989 4.68629 6.68618 2 9.99989 2H33.6922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.278 22.1925L40.9851 22.8996L40.278 22.1925ZM40.278 13.3641L39.5709 14.0712L40.278 13.3641ZM38.6922 8C38.6922 5.23858 36.4536 3 33.6922 3V1C37.5582 1 40.6922 4.13401 40.6922 8H38.6922ZM38.6922 11.9499V8H40.6922V11.9499H38.6922ZM42.5709 17.0712L39.5709 14.0712L40.9851 12.657L43.9851 15.657L42.5709 17.0712ZM39.5709 21.4854L42.5709 18.4854L43.9851 19.8996L40.9851 22.8996L39.5709 21.4854ZM38.6922 28V23.6067H40.6922V28H38.6922ZM33.6922 33C36.4536 33 38.6922 30.7614 38.6922 28H40.6922C40.6922 31.866 37.5582 35 33.6922 35V33ZM9.99989 33H33.6922V35H9.99989V33ZM4.99989 28C4.99989 30.7614 7.23846 33 9.99989 33V35C6.1339 35 2.99989 31.866 2.99989 28H4.99989ZM4.99989 8V28H2.99989V8H4.99989ZM9.99989 3C7.23847 3 4.99989 5.23858 4.99989 8H2.99989C2.99989 4.13401 6.1339 1 9.99989 1V3ZM33.6922 3H9.99989V1H33.6922V3ZM40.9851 22.8996C40.7976 23.0872 40.6922 23.3415 40.6922 23.6067H38.6922C38.6922 22.8111 39.0083 22.048 39.5709 21.4854L40.9851 22.8996ZM43.9851 15.657C45.1567 16.8286 45.1567 18.7281 43.9851 19.8996L42.5709 18.4854C42.9614 18.0949 42.9614 17.4617 42.5709 17.0712L43.9851 15.657ZM40.6922 11.9499C40.6922 12.2151 40.7976 12.4695 40.9851 12.657L39.5709 14.0712C39.0083 13.5086 38.6922 12.7455 38.6922 11.9499H40.6922Z",
    fill: "black",
    fillOpacity: 0.07,
    mask: "url(#path-1-inside-1)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4451 14.7192C28.4451 15.3321 28.1386 16.3536 28.1386 16.9665C28.1386 17.5794 28.4451 17.8858 28.9558 17.988C28.4451 18.1923 28.1386 18.4988 28.1386 19.0095C28.1386 19.6224 28.4451 20.6439 28.4451 21.2568C28.4451 21.8697 28.1386 22.1762 27.5257 22.1762H26.9128V23.2998H27.73C28.8537 23.2998 29.5687 22.7891 29.5687 21.6654C29.5687 20.8482 29.2623 19.8267 29.2623 19.316C29.2623 18.8052 29.4666 18.6009 29.9773 18.6009H30.6924V17.4772H29.9773C29.5687 17.4772 29.2623 17.2729 29.2623 16.8643C29.2623 16.3536 29.5687 15.2299 29.5687 14.5149C29.5687 13.2891 28.8537 12.7783 27.73 12.7783H26.8107V13.902H27.5257C28.0365 13.902 28.4451 14.1063 28.4451 14.7192Z",
    fill: "#787F88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.585 20.9502C25.585 20.3373 25.1764 19.9287 24.5635 19.9287C24.0527 19.9287 23.6441 20.3373 23.6441 20.9502C23.6441 21.5631 24.0527 21.8696 24.5635 21.8696C25.1764 21.8696 25.585 21.461 25.585 20.9502Z",
    fill: "#787F88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1118 20.9502C22.1118 20.3373 21.7032 19.9287 21.1925 19.9287C20.6817 19.9287 20.2731 20.3373 20.2731 20.8481C20.2731 21.3588 20.6817 21.8696 21.1925 21.8696C21.7032 21.8696 22.1118 21.461 22.1118 20.9502Z",
    fill: "#787F88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7407 20.9506C18.7407 20.4399 18.3321 20.0312 17.8214 20.0312C17.3106 20.0312 16.902 20.4399 16.902 20.9506C16.902 21.4614 17.3106 21.87 17.8214 21.87C18.3321 21.87 18.7407 21.4614 18.7407 20.9506Z",
    fill: "#787F88"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6925 17.4772V18.6009H12.4076C12.9183 18.6009 13.1226 18.8052 13.1226 19.316C13.1226 19.8267 12.8162 20.8482 12.8162 21.6654C12.8162 22.8912 13.5312 23.2998 14.6549 23.2998H15.5742V22.2783H14.9613C14.4506 22.2783 14.1441 21.9719 14.1441 21.359C14.1441 20.7461 14.4506 19.7246 14.4506 19.1117C14.4506 18.4988 14.2463 18.1923 13.6334 18.0901C14.1441 17.8858 14.4506 17.5794 14.4506 17.0686C14.4506 16.4557 14.1441 15.4342 14.1441 14.8213C14.1441 14.2084 14.4506 13.902 14.9613 13.902H15.5742V12.7783H14.6549C13.5312 12.7783 12.8162 13.2891 12.8162 14.4127C12.8162 15.2299 13.1226 16.2514 13.1226 16.7622C13.1226 17.2729 12.9183 17.3751 12.4076 17.3751H11.6925V17.4772Z",
    fill: "#787F88"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 47.8639,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.605888 0 0 0 0 0.622106 0 0 0 0 0.670761 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddActionButon);
export default __webpack_public_path__ + "static/media/AddActionButon.200d01611bc3778095b6199771028510.svg";
export { ForwardRef as ReactComponent };